import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import { CLIENT_UNIT_PRICE_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, editClientUnitPrice, getSubmitting } from 'src/reducers/clients/unitPrices';
import { getItem, setItem, getItemErrors } from 'src/reducers/common/itemReducer';
import { setExtras } from 'src/reducers/common/listReducer';
import { getSelectOptions } from 'src/reducers/selectOptions';
import ClientUnitPriceForm from './containers/ClientUnitPriceForm';
import { useTranslation } from 'react-i18next';

let EditUnitPriceForm = reduxForm({
  form: CLIENT_UNIT_PRICE_FORM
})(ClientUnitPriceForm);

const initializeClientAllowanceId = clientAllowances =>
  clientAllowances.map(clientAllowance => (clientAllowance.value ? clientAllowance.id : false));

const mapStateToProps = state => ({
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: {
    ...getItem(REDUCER_NAME, state),
    clientAllowanceId: initializeClientAllowanceId(getSelectOptions(state, 'clientAllowances'))
  },
  isSubmitting: getSubmitting(state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(editClientUnitPrice(data));
  },
  setSubmitting: () => {
    dispatch(setExtras(REDUCER_NAME, { submitting: true }));
  }
});

EditUnitPriceForm = connect(mapStateToProps, mapDispatchToProps)(EditUnitPriceForm);

const EditClientUnitPrice = ({ dispatch, values, match, payrollRulesGroup }) => {
  const { t } = useTranslation();
  const { payrollRulesGroupId } = match.params;
  dispatch(setItem(REDUCER_NAME, values));
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.ClientUnitPrices.EditClientUnitPrice.Unit_price_edit')}</h1>
      </div>
      <div className="l-wrap-xs">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('features.ClientUnitPrices.ClientUnitPricesList.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.ClientUnitPrices.ClientUnitPricesList.salary_rule_group_list')} path={CLIENT_PAYROLL_RULES_GROUP_LIST} />
            <BreadCrumb.Item
              label={t('features.ClientUnitPrices.ClientUnitPricesList.provision_deduction_item_list')}
              path={`/clients/payroll_rules_groups/${payrollRulesGroupId}/allowances`}
            />
            <BreadCrumb.Item
              label={t('features.ClientUnitPrices.EditClientUnitPrice.unit_price_list')}
              path={`/clients/payroll_rules_groups/${payrollRulesGroupId}/unit_prices`}
            />
            <BreadCrumb.Item label={t('features.ClientUnitPrices.EditClientUnitPrice.Unit_price_edit')} />
          </BreadCrumb>
        </div>
        <EditUnitPriceForm payrollRulesGroup={payrollRulesGroup} />
      </div>
    </div>
  );
};

export default connect()(EditClientUnitPrice);
